import { Keyboard, Info, Files } from 'lucide-react';
import { useToastStore } from '@/stores/toast-store';
import type { Command } from '../types';

/**
 * Meta / help commands. Keep this small — these are the commands users
 * find when they're looking for "everything else".
 */
export const metaCommands: Command[] = [
  {
    id: 'help.shortcuts',
    label: 'Show Keyboard Shortcuts',
    icon: Keyboard,
    category: 'Help',
    keywords: ['kbd', 'hotkeys', 'bindings'],
    run: () => {
      // TODO: a dedicated shortcuts sheet would be nicer. Toast for now.
      useToastStore.getState().addToast(
        'info',
        'Cmd+P search · Cmd+Shift+P commands · Cmd+B sidebar · Cmd+J bottom panel · Cmd+T new query · Cmd+W close tab',
      );
    },
  },
  {
    id: 'help.about',
    label: 'About DBGo',
    icon: Info,
    category: 'Help',
    run: () => {
      useToastStore.getState().addToast(
        'info',
        'DBGo v2.0 — Browser-based DB workbench. See CLAUDE.md and PLAN.md in the repo.',
      );
    },
  },
  {
    id: 'files.upload',
    label: 'Upload Files (CSV / JSON / Parquet / Excel / SQLite)...',
    icon: Files,
    category: 'UI',
    keywords: ['csv', 'excel', 'duckdb', 'import'],
    run: () => {
      // Trigger the same handler the sidebar "Upload Files" button uses.
      window.dispatchEvent(new CustomEvent('dbgo:files:upload'));
    },
  },
];
